import { useState } from "react";
import { absoluteTime, formatTime } from "../data";
import ResourceTooltip from './ResourceTooltip';
import { Tooltip } from 'react-tooltip';
import { useDragContext } from './DragContext';

export const TransportActionView = ({startTime, action, planets, onMoveAction, onDeleteAction, onToggleDeactivate, last, changeTransportAction}) => {
    // Determine if the action is deactivated
    const isDeactivated = action.deactivated === true;
    const [settings, setSettings] = useState(action.payload.settings);
    const [showTooltip, setShowTooltip] = useState(false);
    const { isDragging } = useDragContext();
    
    // Check if we have state data to show in tooltip
    const hasStateData = action.stateAfter || action.stateBefore;
    
    // Don't show tooltip when dragging
    const shouldShowTooltip = showTooltip && !isDragging && hasStateData;

    const handleChange = (e) => {
        const { name, value, checked } = e.target;
        setSettings((prev) => {
            // prev.startTime = new Date(value);
            if(name == "flight_time")
              prev[name] = input_to_time(value);
            else
              prev[name] = value === 'on' ? checked : parseInt(value);
            changeTransportAction(action.planetId, action.index, prev);
            return { ... prev };
        });
    }

    const time_to_input = (hours) => 
    {
      const totalSeconds = Math.floor(hours * 3600); // Convert hours to total seconds
      
      const days = Math.floor(totalSeconds / (24 * 3600));
      const remainingSecondsAfterDays = totalSeconds % (24 * 3600);
      
      const hrs = Math.floor(remainingSecondsAfterDays / 3600);
      const remainingSecondsAfterHours = remainingSecondsAfterDays % 3600;
      
      const mins = Math.floor(remainingSecondsAfterHours / 60);
      const secs = remainingSecondsAfterHours % 60;

      
      return `${hrs < 10 ? "0" + hrs : hrs}:${mins < 10 ? "0" + mins : mins}:${secs < 10 ? "0" + secs : secs}`;
    }

    const input_to_time = (value) =>
    {
      const parts = value.split(':');
      if(parts.length < 3)
        return 0;
      const hrs = parseInt(parts[0]);
      const min = parseInt(parts[1]);
      const sec = parseInt(parts[2]);
      return hrs + min / 60 + sec / 3600;
    }

    return (
        <li 
          key={action.index} 
          className={"col-span-1 m-0 p-1 rounded-sd shadow-sd flex justify-between items-start " + 
            (isDeactivated ? "bg-gray-600 opacity-70 " : action.valid ? "bg-gray-800" : "bg-red-400")}
          data-tooltip-id={`tooltip-${action.index}`}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
            <div className="">
                {/* Action Summary */}
                <div className={"font-semibold text-left " + (isDeactivated ? "text-gray-400" : "text-gray-200")}>
                  {isDeactivated ? "[Deactivated] " : ""}Transport
                </div>
                {/* Start Time and End Time */}
                <div className="text-sm text-gray-400 text-left">
                  Start: {absoluteTime(startTime, action.startTime)}
                </div>
                <div className="p-4 bg-gray-800 text-white rounded-lg shadow-md space-y-4">

                    {/* Row with Label and Select Inputs */}
                    <div className="flex items-center space-x-4">
                        <label className="text-gray-300 font-medium">Target:</label>
                        <div className="flex items-center space-x-4">
                        <select value={settings.target} onChange={handleChange} name="target" className="bg-gray-700 text-white p-1 rounded-md">
                            <option value="0">None</option>
                            { Object.keys(planets).filter(x => x != action.planetId).map((planet) => (
                                <option value={planet}>{planets[planet].name}</option>
                            ))
                            }
                        </select>
                        </div>
                        <label className="text-gray-300 font-medium">Flight:</label>
                        <div className="flex items-center space-x-4">
                          <input type="time" name="flight_time" onChange={handleChange} value={time_to_input(settings.flight_time)} step="1" className="bg-gray-700 text-white p-1 rounded-md" />
                        </div>
                    </div>


                    <div className="flex text-center justify-between items-center space-x-4">
                        <label className="text-gray-300 font-medium">Metal:</label>
                        <input type="number" name="metal" onChange={handleChange} value={settings.metal} step="1" className="bg-gray-700 text-white p-1 rounded-md" />
                    </div>
                    <div className="flex text-center justify-between items-center space-x-4">
                        <label className="text-gray-300 font-medium">Crystal:</label>
                        <input type="number" name="crystal" onChange={handleChange} value={settings.crystal} step="1" className="bg-gray-700 text-white p-1 rounded-md" />
                    </div>
                    <div className="flex text-center justify-between items-center space-x-4">
                        <label className="text-gray-300 font-medium">Deut:</label>
                        <input type="number" name="deuterium" onChange={handleChange} value={settings.deuterium} step="1" className="bg-gray-700 text-white p-1 rounded-md" />
                    </div>
                </div>
              </div>
              
              {/* Tooltip */}
              {shouldShowTooltip && (
                <Tooltip
                  id={`tooltip-${action.index}`}
                  place="right"
                  className="z-50"
                  style={{ backgroundColor: 'transparent', padding: 0, border: 'none' }}
                >
                  <ResourceTooltip 
                    beforeState={action.stateBefore} 
                    afterState={action.stateAfter} 
                  />
                </Tooltip>
              )}
              
              {/* Action Control Buttons */}
              {action.editable && (
                <div className="flex items-center space-x-1">
                  {/* Move Up Button */}
                  {action.index !== 0 && (
                    <button
                      onClick={() => onMoveAction(action.planetId, action.index, 'up')}
                      className="bg-gray-600 hover:bg-gray-500 text-white px-2 rounded text-xs"
                      disabled={action.index === 0} // Disable if it's the first item
                    >
                      ▲
                    </button>
                  )}

                  {/* Move Down Button */}
                  { !last && (
                    <button
                      onClick={() => onMoveAction(action.planetId, action.index, 'down')}
                      className="bg-gray-600 hover:bg-gray-500 text-white px-2 rounded text-xs"
                      disabled={last} // Disable if it's the last item
                    >
                      ▼
                    </button>
                  )}
                  

                  {/* Toggle Deactivate Button */}
                  <button
                    onClick={() => onToggleDeactivate(action.planetId, action.index)}
                    className={(isDeactivated ? "bg-green-600 hover:bg-green-700" : "bg-yellow-600 hover:bg-yellow-700") + " text-white px-2 rounded text-xs"}
                    title={isDeactivated ? "Activate" : "Deactivate"}
                  >
                    {isDeactivated ? "✓" : "⏸"}
                  </button>

                  {/* Delete Button */}
                  <button
                    onClick={() => onDeleteAction(action.planetId, action.index)}
                    className="bg-red-600 hover:bg-red-700 text-white px-2 rounded text-xs"
                  >
                    X
                  </button>
                </div>
              )}
              
            </li>
    );
}